<script setup>
import { useWorkspaceV2 } from 'dashboard/composables/useWorkspaceV2';
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import CompanySortMenu from './components/CompanySortMenu.vue';
import CompanyMoreActions from './components/CompanyMoreActions.vue';
defineProps({
  showSearch: { type: Boolean, default: true },
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  activeSort: { type: String, default: 'last_activity_at' },
  activeOrdering: { type: String, default: '' },
});
const emit = defineEmits(['search', 'update:sort', 'create']);
const { isWorkspaceV2 } = useWorkspaceV2();
</script>

<template>
  <header
    class="sticky top-0 z-10 px-6"
    :class="{ 'border-b border-n-weak bg-n-solid-1': isWorkspaceV2 }"
  >
    <div
      class="flex items-start sm:items-center justify-between w-full py-6 gap-2 mx-auto max-w-5xl"
      :class="{
        '!flex-col !items-stretch !gap-4 sm:!flex-row sm:!items-center':
          isWorkspaceV2,
      }"
    >
      <h1
        class="m-0 text-xl font-medium truncate text-n-slate-12"
        :class="{ '!text-[26px] !font-semibold': isWorkspaceV2 }"
      >
        {{ headerTitle }}
      </h1>
      <div
        class="flex items-center flex-col sm:flex-row flex-shrink-0 gap-4"
        :class="{ '!items-stretch !gap-2 sm:!items-center': isWorkspaceV2 }"
      >
        <div v-if="showSearch" class="flex items-center gap-2 w-full">
          <Input
            :model-value="searchValue"
            type="search"
            :placeholder="$t('COMPANIES.SEARCH_PLACEHOLDER')"
            :custom-input-class="[
              'h-8 [&:not(.focus)]:!border-transparent bg-n-alpha-2 dark:bg-n-solid-1 ltr:!pl-8 !py-1 rtl:!pr-8',
              isWorkspaceV2 ? '!h-11 !rounded-xl' : '',
            ]"
            class="w-full"
            @input="emit('search', $event.target.value)"
          >
            <template #prefix>
              <Icon
                icon="i-ri-search-line"
                class="absolute -translate-y-1/2 text-n-slate-11 size-4 top-1/2 ltr:left-2 rtl:right-2"
              />
            </template>
          </Input>
        </div>
        <div class="flex items-center flex-shrink-0 gap-2">
          <CompanySortMenu
            :active-sort="activeSort"
            :active-ordering="activeOrdering"
            @update:sort="emit('update:sort', $event)"
          />
          <CompanyMoreActions @create="emit('create')" />
        </div>
      </div>
    </div>
  </header>
</template>
